import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { ReactComponent as BackCircle } from '../../../../../assets/icons/backCircle.svg';
import { ReactComponent as GrayLinkIcon } from '../../../../../assets/icons/grayLink.svg';
import { ReactComponent as CopyprimaryIcon } from '../../../../../assets/icons/copyprimary.svg';
import { ReactComponent as ThreedotsIcon } from '../../../../../assets/icons/threedots.svg';
import { ReactComponent as ApiIcon } from '../../../../../assets/icons/api.svg';
import { ReactComponent as Pluswhite } from '../../../../../assets/icons/Pluswhite.svg';
import { ReactComponent as PlayIcon } from '../../../../../assets/icons/play.svg';
import { ReactComponent as PushIcon } from '../../../../../assets/icons/pause.svg';
import { Image, Nav } from "react-bootstrap";
import searchIcon from "../../../../../assets/icons/search.svg";
import { ReactComponent as ResultSearchIcon } from '../../../../../assets/icons/searchicon.svg';
import Countes from '../../../../../components/IVR/Countes';
import GenerateApi from './Modal/GenerateApi';
import LeadsFooterBar from '../../../../LeadsManager/LeadsFooterBar';
import NewIntegration from './Modal/NewIntegration';
import { toast } from 'react-toastify';
import { addKnowlarityIntegration, addKnowlarityUserMapping, generateMyOperatorApikey, getKnowlarityCallLogStats, getKnowlarityCallLogs, getIvrIntegrationByUUID, getKnowlarityIvrIntegrations, getKnowlarityIvrUserMapping, getMyOperatorApikey, updateKnowlarityIntegration, getKnowlarityIvrIntegrationByUUID, addKnowlarityUserCallerIDMapping, getKnowlarityIvrUserCallerIdMapping } from '../../../../../services/private/company.service';
import moment from 'moment';
// import SearchIcon from '../../../../../assets/icons/search.svg';

const Knowlarity = () => {

    const [showApiModal, setShowApiModal] = useState(false);
    const [showIntegrationModal, setShowIntegrationModal] = useState(false);
    const [integrationUuid, setIntegrationUuid] = useState();
    const [keyNotFound, setKeyNotFound] = useState(false);
    const [apiKey, setApikey] = useState('');
    const [integrations, setIntegrations] = useState([]);
    const [formSteps, setFormSteps] = useState('basic');
    const [selectedIntegration, setSelectedIntegration] = useState({});
    const [useMappingData, setUserMappingData] = useState([]);
    const [callerIdMappingData, setCallerIdMappingData] = useState([])
    const [callLogs, setCallLogs] = useState([]);
    const [selectedRecording, setSelectedRecording] = useState('');
    const [callsStats, setCallsStats] = useState({});
    const [showingResults, setShowingResults] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [leadsCount, setLeadsCount] = useState();

    // const getMyOperatorKey = async () => {
    //     try {
    //         const res = await getMyOperatorApikey()
    //         if (res.data.status === 200) {
    //             setApikey(res.data.data.key);
    //             setKeyNotFound(false);
    //             getIntegrations();
    //         }
    //     } catch (err) {
    //         if (err.response.data.status === 404) {
    //             setKeyNotFound(true);
    //         }
    //     }
    // }

    // const generateOperatorKey = async () => {
    //     const res = await generateMyOperatorApikey();
    //     if (res.data.status === 200) {
    //         toast.success(res.data.message);
    //         setApikey(res.data.data.key);
    //         setShowApiModal(true);
    //     }
    // }

    const getIntegrations = async () => {
        const res = await getKnowlarityIvrIntegrations();
        if (res.data.status === 200) {
            // console.log(res.data.data);
            setIntegrations(res.data.data)
        }
    }

    const getIntegrationData = async (uuid, showModal) => {
        const res = await getKnowlarityIvrIntegrationByUUID(uuid)
        if (res.data.status === 200) {
            console.log(res.data.data, 'by uuid');
            setSelectedIntegration(res.data.data);
            if (!showModal) {
                navigator.clipboard.writeText(`https://api.propacity.in/api/v1/webhooks/knowlarity/${res.data.data?.integration.api_key}/postdata`).then(function () {
                    toast.success('API key Copied');
                }, function (err) {
                    toast.error('Could not copy');
                });
            }
            setShowIntegrationModal(showModal)
        }
    }

    const getUserMapping = async (uuid) => {
        const res = await getKnowlarityIvrUserMapping(uuid);
        if (res.data.status === 200) {
            // console.log(res.data.data, 'userMapping')
            setUserMappingData(res.data.data);
            setFormSteps('mapping');
        }
    }

    const getCallerIdMapping = async (uuid) => {
        const res = await getKnowlarityIvrUserCallerIdMapping(uuid);
        if (res.data.status === 200) {
            setCallerIdMappingData(res.data.data)
            setFormSteps('caller')
        }
    }

    const getIVRStats = async () => {
        const res = await getKnowlarityCallLogStats();
        if (res.data.status === 200) {
            const totalPages = Math.ceil(
                Number(res.data.data[0].calls_received) / parseInt(showingResults)
            );
            setMaxPage(totalPages);
            let seconds = res.data.data[0].total_talk_time
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);

            seconds = seconds % 60;
            // if seconds are greater than 30, round minutes up (optional)
            minutes = seconds >= 30 ? minutes + 1 : minutes;

            minutes = minutes % 60;

            //  If you don't want to roll hours over, e.g. 24 to 00
            //  comment (or remove) the line below
            // commenting next line gets you `24:00:00` instead of `00:00:00`
            // or `36:15:31` instead of `12:15:31`, etc.
            hours = hours % 24;
            setCallsStats({ ...res.data.data[0], total_talk_time: `${hours}:${minutes} hrs` })
        }
    }

    const getIVRCallLog = async () => {

        const res = await getKnowlarityCallLogs(showingResults, currentPage);
        if (res.data.status === 200) {
            setCallLogs(res.data.data);
            // console.log(res.data.data, 'res.data.data')            
            setLeadsCount(res.data.data.length);
        }
    }

    useEffect(() => {
        // getMyOperatorKey();
        getIVRStats();
        getIntegrations();

        // getIntegrations();
        // getUserMapping();
    }, []);

    useEffect(() => {
        getIVRCallLog();

        // pagination
        const totalPages = Math.ceil(
            Number(callsStats?.calls_received) / parseInt(showingResults)
        );
        setMaxPage(totalPages);
    }, [showingResults, currentPage]);

    const handleCreateIntegration = async (data) => {
        const payload = data;
        const res = await addKnowlarityIntegration(payload);
        if (res.data.status === 200) {
            toast.success(res.data.message);
            // console.log(res.data.data, 'created integration')
            setFormSteps('mapping');
            setIntegrationUuid(res.data.data.uuid)
        }
    }

    const handleUpdateIntegration = async (payload) => {
        const res = await updateKnowlarityIntegration(selectedIntegration.integration.uuid, payload);
        if (res.data.status === 200) {
            // console.log(res.data.data)
            toast.success(res.data.message);
            getUserMapping(selectedIntegration.integration.uuid);
            setIntegrationUuid(selectedIntegration.integration.uuid)
            // setFormSteps('mapping');
        }
    }

    const handleSaveUserMapping = async (data) => {
        const payload = data;
        const res = await addKnowlarityUserMapping(integrationUuid || selectedIntegration?.integration?.uuid, payload);
        if (res.data.status === 200) {
            toast.success(res.data.message);
            // getIntegrations();
            // console.log(res.data.data);
            // setShowIntegrationModal(false);
            getCallerIdMapping(selectedIntegration.integration.uuid);
            // setFormSteps('caller');
        }
    }

    const handleSaveCallerMapping = async (data) => {
        const payload = data;
        const res = await addKnowlarityUserCallerIDMapping(integrationUuid || selectedIntegration?.integration?.uuid, payload);
        if (res.data.status === 200) {
            toast.success(res.data.message);
            getIntegrations();
            // console.log(res.data.data);            
            setSelectedIntegration({});
            setUserMappingData([]);
            setFormSteps('basic');
            setShowIntegrationModal(false);
            setCallerIdMappingData([])
        }
    }

    return (
        <>
            <div className="w-full flex flex-col h-full">
                <div className="settings-title pb-0">
                    <div className="row">
                        <div className="col-12">
                            <nav aria-label="breadcrumb" className='inner-page-breadcrumb'>
                                <ul className="d-flex align-items-center justify-content-start flex-row mb-8">
                                    <li>
                                        <Link to='/settings/integrations/all-integrations'>All integrations </Link>
                                    </li>
                                    <li className='flex items-center'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                                        <path d="M4 3.5L8.5 8L4 12.5" stroke="#696974" />
                                    </svg>
                                        IVR Integration
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div className="row d-flex flex-fill flex-xl-nowrap flex-wrap align-items-end">
                        <div className="col-lg-6 col-md-12 d-flex flex-fill flex-column">
                            <h1 className='text-2xl font-semibold !text-textblack inter mb-0  ls5 d-inline-flex align-items-center'>
                                {/* <Link to='/settings/integrations/all-integrations' className='pr-hover'><BackCircle className='mr-8' /></Link> */}
                                Knowlarity IVR
                            </h1>

                        </div>
                        {!keyNotFound && <div className="col-lg-6 col-md-12 justify-content-lg-end mt-lg-0 mt-3 d-flex flex-fill align-items-center gap-x-3">

                            {/* <div className={`form-group position-relative search-input`}>
                                <div className="serch-icon">
                                    <Image src={searchIcon} />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search Page Name"
                                    // value={searchText}
                                    // onChange={(e) => setSearchText(e.target.value)}
                                    className={`searchinput`}
                                />
                                <div className="close-icon" style={{ top: '12px' }} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.94131 5.00019L9.45935 8.52142C9.71958 8.78188 9.71939 9.20399 9.45892 9.46423C9.19845 9.72446 8.77634 9.72427 8.51611 9.4638L4.9978 5.9423L1.47122 9.46365C1.21067 9.7238 0.788564 9.72349 0.528408 9.46295C0.268252 9.2024 0.268566 8.78029 0.529109 8.52014L4.05542 4.99907L0.53071 1.47117C0.270478 1.2107 0.270669 0.788594 0.531136 0.528362C0.791603 0.26813 1.21371 0.268321 1.47395 0.528788L4.99893 4.05696L8.51612 0.544989C8.77666 0.284833 9.19877 0.285147 9.45893 0.54569C9.71909 0.806233 9.71877 1.22834 9.45823 1.4885L5.94131 5.00019Z" fill="#696974" />
                                    </svg>
                                </div>
                            </div>

                            <div className="filter-btn">
                                <button className={`d-flex align-items-center " border-0 pr-hover  active" : "border-0 btn"}`} type="button" >
                                    <svg className="mr-8" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M12.981 11.1747V15.5775C12.981 15.9053 12.7958 16.2049 12.5026 16.3515L9.04095 18.0823C8.46554 18.37 7.78852 17.9516 7.78852 17.3083V11.1747L1.92626 4.00973C1.46395 3.44468 1.86597 2.59631 2.59606 2.59631H18.1734C18.9035 2.59631 19.3056 3.44468 18.8432 4.00973L12.981 11.1747ZM11.2502 15.0426V10.8658C11.2502 10.666 11.3193 10.4724 11.4458 10.3178L16.3472 4.32713H4.42228L9.32372 10.3178C9.45022 10.4724 9.51934 10.666 9.51934 10.8658V15.908L11.2502 15.0426Z" fill="#696974"></path></svg>
                                    <span className="text-capitalize">Filter</span>

                                </button>
                            </div> */}

                            <div className="d-inline-block">
                                <button className='pr-btn d-inline-flex align-items-center  px-16' onClick={() => setShowIntegrationModal(true)}>
                                    <svg className="mr4 d-xl-inline-block d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                                    <span className="d-xl-inline d-none ml-0 ">Add New</span>
                                    <span className="d-xl-none ml-0">Add New</span>
                                </button>

                            </div>
                            {/* <div className="dropdown view-more">
                                <button className="bg-tr border-0 " type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z" fill="#696974" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z" fill="#696974" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z" fill="#696974" />
                                    </svg>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                     <Link className="dropdown-item" to='/settings/integrations/all-integrations/manage-accounts' >Edit Integration</Link>
                                    <Link className="dropdown-item del-menu-itme" to='/settings/integrations/all-integrations/manage-accounts' >Delete</Link>
                                    <a className="dropdown-item" >Edit Integration</a>
                                    <a className="dropdown-item del-menu-itme" >Delete</a>
                                </div>

                            </div> */}
                        </div>}
                    </div>

                    {!keyNotFound && <div className='!mt-4'>
                        <nav className='tabs-bottom-active-border'>
                            <div className="nav nav-tabs border-0 !mb-2 gap-x-6" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item inter !text-base font-medium !text-textblack !p-0 border-0 m-0 nav-link hover:!text-primary active"
                                    id="nav-ivr-tab"
                                    data-toggle="tab"
                                    href="#nav-ivr"
                                    role="tab"
                                    aria-controls="nav-ivr"
                                    aria-selected="true"

                                >IVR</a>
                                <a
                                    className="nav-item inter !text-base font-medium !text-textblack !p-0 border-0 m-0 nav-link hover:!text-primary"
                                    id="nav-CallRecording-tab"
                                    data-toggle="tab"
                                    href="#nav-CallRecording"
                                    role="tab"
                                    aria-controls="nav-CallRecording"
                                    aria-selected="false"
                                    onClick={() => {
                                        setCurrentPage(1);
                                        setShowingResults(10);
                                    }}
                                >
                                    Call Logs/Recordings
                                </a>

                            </div>
                        </nav>

                    </div>}
                </div>
                {!keyNotFound && <div className='flex h-100 bg-white  !pt-5  overflow-hidden'>
                    <div className='w-100 [&>*]:h-full h-full'>
                        <div className="tab-content w-100 [&>*]:h-full" id="nav-tabContent">
                            <div className="tab-pane fade show active" id="nav-ivr" role="tabpanel" aria-labelledby="nav-ivr-tab">
                                <div className='flex flex-col h-full !pl-6'>
                                    {/* <div className='inter flex flex-col items-start'>
                                        <p className='inline-flex items-center m-0 text-sm text-black700 font-medium gap-x-1.5'>API for MyOperator <GrayLinkIcon /></p>
                                        <div className='!mt-2 inline-flex gap-x-2'>
                                            <input
                                                type="text"
                                                className='!border !border-grayLight rounded-lg outline-0 focus:!border-primary px-3 py-2 shadow-shadowxs text-textblack text-base'
                                                placeholder='www.untitledui.com/blog'
                                                value={`https://api.propacity.in/api/v1/webhooks/integration/${apiKey}/myOperatorHook`}
                                                readOnly
                                            />
                                            <button
                                                className='inline-flex items-center gap-x-2.5 !text-primary bg-blue100 px-4 rounded-lg text-sm font-medium inter'
                                                onClick={() => {
                                                    navigator.clipboard.writeText(`https://api.propacity.in/api/v1/webhooks/integration/${apiKey}/myOperatorHook`).then(function () {
                                                        toast.success('API key Copied');
                                                    }, function (err) {
                                                        toast.error('Could not copy');
                                                    });
                                                }}
                                            >
                                                <CopyprimaryIcon /> Copy API </button>
                                        </div>
                                    </div> */}

                                    <div className='flex items-start gap-x-5'>
                                        <Countes heading={callsStats?.calls_received || '-'} subheading='Calls Received' />
                                        <Countes heading={callsStats?.calls_missed || '-'} subheading='Calls Missed' />
                                        <Countes heading={callsStats?.calls_answered || '-'} subheading='Calls Answered' />
                                        <Countes heading={callsStats?.connected_calls || '-'} subheading='Connected Calls' />
                                        <Countes heading={callsStats?.total_talk_time || '-'} subheading='Talk Time' />

                                    </div>
                                    <div className='h-full overflow-auto !pt-5 w-full'>
                                        <div className='def-table pr-24 !h-full'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>IVR No.</th>
                                                        <th>Call forwarding</th>
                                                        <th>Project</th>
                                                        <th>Source</th>
                                                        <th>Call Forwarding Status</th>
                                                        <th>Created By</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        integrations.length > 0 && integrations.map((item, index) => (
                                                            <tr key={`${item.uuid}_${index}`}>
                                                                <td> {index + 1}</td>
                                                                <td> {item?.ivr_number || '-'}</td>
                                                                <td className='flex'>
                                                                    {item?.call_forwarding_numbers?.length > 0 ? <span>{item?.call_forwarding_numbers[0]}</span> : '-'}
                                                                    {
                                                                        item?.call_forwarding_numbers?.length > 1 ? <div className="tag-dropdown ml-1" >
                                                                            <button className="border-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                +{item.call_forwarding_numbers.length - 1}
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                                {item.call_forwarding_numbers.map((call, index) => {
                                                                                    return <a key={index} className="dropdown-item text-capitalize"  >
                                                                                        {call}
                                                                                        {/* {index == 0 ? <span className='drop-tag'>Primary</span> : ''} */}
                                                                                    </a>

                                                                                })}
                                                                            </div>
                                                                        </div> : ""
                                                                    }
                                                                </td>
                                                                <td> {item?.name || '-'}</td>
                                                                <td> {item?.display_name || '-'}</td>
                                                                <td>
                                                                    <button className={`rounded ${item?.call_forwarding ? 'bg-blue100 !text-primary' : 'bg-black200 !text-black700'}  px-2.5 !py-1 text-xs font-medium inter`}>{item?.call_forwarding ? 'Yes' : 'No'}</button>
                                                                    {/* <button className='rounded  px-2.5 !py-1 text-xs font-medium inter'>No</button> */}
                                                                </td>
                                                                <td> {item?.added_by}</td>

                                                                <td className='dropdown view-more'>
                                                                    <button className="bg-tr border-0 px-0" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                        <ThreedotsIcon />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">

                                                                        <a className='dropdown-item' onClick={() => {
                                                                            getIntegrationData(item.uuid, true)
                                                                        }}>Edit Integration</a>
                                                                        <a className='dropdown-item' onClick={() => {
                                                                            getIntegrationData(item.uuid, false)
                                                                        }}>Copy API url</a>
                                                                        {/* <a className="dropdown-item !text-red hover:!bg-red hover:!text-white">Delete</a> */}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                    {integrations?.length === 0 &&
                                                        <tr className='nohover'>
                                                            <td colSpan={12} style={{ height: '40vh' }}>
                                                                <div className='flex justify-center flex-column items-center'>
                                                                    <figure><ResultSearchIcon /></figure>
                                                                    <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize">No Integrations Added</h2>
                                                                    {/* <p className='text-center black-dark-600 fz14 mb-4 text-capitalize'>Please add projects to see them here</p> */}
                                                                    {/* <button className={`${style.addnewprojectbtn}`}>+ New Project</button> */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-CallRecording" role="tabpanel" aria-labelledby="nav-CallRecording-tab">
                                <div className='flex flex-col h-full'>
                                    <div className='h-full overflow-auto  w-full !pl-6'>
                                        <div className='def-table pr-24 !h-full'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Customer Name</th>
                                                        <th>Mobile</th>
                                                        <th>Status</th>
                                                        <th>Recording</th>
                                                        <th>IVR No.</th>
                                                        <th>Call Forwarded No.</th>
                                                        <th>Assigned User</th>
                                                        <th>Call Date Time</th>
                                                        <th>Project</th>
                                                        <th>Source</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        callLogs?.length > 0 && callLogs.map((log, index) => (
                                                            <tr key={log.uuid}>
                                                                <td> {index + 1}</td>
                                                                <td>{log.name || '-'}</td>
                                                                <td>{log.mobile || '-'}</td>
                                                                <td>
                                                                    {log.status === 'missed' && <div className='text-xs font-medium !text-red !bg-red-light !py-1 rounded-lg capitalize text-center px-2 max-w-[130px]'>{log.status}</div>}
                                                                    {log.status === 'not connected' && <div className='text-xs font-medium !text-orange-dark !bg-orange-100 !py-1 rounded-lg capitalize text-center px-2 max-w-[130px]'>{log.status}</div>}
                                                                    {(log.status === 'connected' || log.status === 'Connected') && <div className='text-xs font-medium !text-green !bg-green100 !py-1 rounded-lg text-center px-2 max-w-[130px]'>Answered</div>}
                                                                    {log.status === 'voicemail' && <div className='text-xs font-medium !text-green !bg-green100 !py-1 rounded-lg text-center px-2 max-w-[130px]'>Voicemail</div>}
                                                                </td>
                                                                <td>
                                                                    {log?.call_recording_link && !log?.isAudioPlay && <button className='strokeprimary'
                                                                        onClick={() => {
                                                                            setSelectedRecording(log.call_recording_link)
                                                                            let callLogsCopy = [...callLogs];
                                                                            callLogsCopy[index].isAudioPlay = true;
                                                                            setCallLogs(callLogsCopy);
                                                                        }}
                                                                    ><PlayIcon /></button>}
                                                                    {log?.isAudioPlay && <button
                                                                        className='strokeprimary'
                                                                        onClick={() => {
                                                                            setSelectedRecording('')
                                                                            let callLogsCopy = [...callLogs];
                                                                            callLogsCopy[index].isAudioPlay = false;
                                                                            setCallLogs(callLogsCopy);
                                                                        }}
                                                                    >
                                                                        <PushIcon /></button>}
                                                                </td>
                                                                <td>{!log?.call_forwarding ? log?.ivr_number || '-' : '-'}</td>
                                                                <td className='flex'>
                                                                    {log?.call_forwarded_number || '-'}
                                                                </td>
                                                                <td>{log?.assigned_user_name || log?.received_user_number || '-'}</td>
                                                                <td> {moment(log?.call_start_time).format('hh:mm a, Do MMM YYYY')}</td>
                                                                <td>{log?.project_name || '-'}</td>
                                                                <td>{log?.source_name || '-'}</td>
                                                                {log?.lead_uuid && <td className='dropdown view-more'>
                                                                    <button className="bg-tr border-0 px-0" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                        <ThreedotsIcon />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">

                                                                        <a className='dropdown-item' href={`/leads/${log?.lead_uuid}`} target='_blank'>View Lead</a>

                                                                    </div>
                                                                </td>}

                                                            </tr>
                                                        ))
                                                    }

                                                    {callLogs?.length === 0 &&
                                                        <tr className='nohover'>
                                                            <td colSpan={12} style={{ height: '50vh' }}>
                                                                <div className='flex justify-center flex-column items-center'>
                                                                    <figure><ResultSearchIcon /></figure>
                                                                    <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize">No Call Logs Added</h2>
                                                                    {/* <p className='text-center black-dark-600 fz14 mb-4 text-capitalize'>Please add projects to see them here</p> */}
                                                                    {/* <button className={`${style.addnewprojectbtn}`}>+ New Project</button> */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                    {selectedRecording && <div className='!pr-5'>
                                        <audio controls className='w-full' download>
                                            <source src={selectedRecording} type="audio/mpeg" />
                                        </audio>
                                    </div>}
                                    <div className='[&>*]:!relative [&>*]:!w-full'>
                                        <LeadsFooterBar
                                            showingResults={showingResults}
                                            setShowingResults={setShowingResults}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            maxPage={maxPage}
                                            leadsCount={leadsCount}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>}

                {/* {
                    keyNotFound && <div className='h-full flex flex-col items-center justify-center'>
                        <figure className='m-0'><ApiIcon /></figure>
                        <p className='text-sm inter text-black700 font-medium m-0'>Generate API For IVR Integration</p>
                        <button className='!mt-5 !bg-primary text-white rounded-lg text-sm font-medium inter px-4 py-2.5 inline-flex items-center' onClick={generateOperatorKey}><Pluswhite /> Generate API</button>

                    </div>

                } */}
            </div >

            {showApiModal && <GenerateApi
                show={showApiModal}
                closeModal={() => setShowApiModal(false)}
                // generateOperatorKey={generateOperatorKey}
                ivrName={'Knowlarity'}
                // getMyOperatorKey={getMyOperatorKey}
                apiKey={apiKey}
            />}
            {showIntegrationModal && <NewIntegration
                show={showIntegrationModal}
                closeModal={() => {
                    setSelectedIntegration({});
                    setUserMappingData([]);
                    setFormSteps('basic');
                    setShowIntegrationModal(false);
                    setCallerIdMappingData([])
                }}
                ivrName={'Knowlarity'}
                handleCreateIntegration={handleCreateIntegration}
                handleSaveUserMapping={handleSaveUserMapping}
                handleSaveCallerMapping={handleSaveCallerMapping}
                formSteps={formSteps}
                setFormSteps={setFormSteps}
                selectedIntegration={selectedIntegration}
                handleUpdateIntegration={handleUpdateIntegration}
                useMappingData={useMappingData}
                getUserMapping={getUserMapping}
                getCallerIdMapping={getCallerIdMapping}
                callerIdMappingData={callerIdMappingData}
            />}
        </>
    )
}

export default Knowlarity;
